import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-processing',
  templateUrl: './wait-processing.component.html',
  styleUrls: ['./wait-processing.component.css']
})
export class WaitProcessingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/wait-processing/wait-processing.component.ts